import styled from 'styled-components/macro';
import {
  compose,
  space,
  color,
  border,
  typography,
  flexbox,
  position,
  layout,
  variant,

  // types
  SpaceProps,
  TypographyProps,
  ColorProps,
  BorderProps,
  FlexboxProps,
  PositionProps,
  LayoutProps,
  ButtonStyleProps,
} from 'styled-system';

import { css } from '@styled-system/css';

type ButtonProps = SpaceProps &
  TypographyProps &
  ColorProps &
  BorderProps &
  FlexboxProps &
  PositionProps &
  LayoutProps &
  ButtonStyleProps;

const Button = styled.button<ButtonProps>`
  appearance: none;
  white-space: nowrap;

  svg {
    ${css({ mx: 1 })}
  }

  ${variant({
    variants: {
      primary: {
        color: 'white',
        bg: 'AccentGreen',
        '&:hover, &:focus': {
          filter: 'brightness(95%)',
        },
      },
      primary2: {
        color: 'AccentGreen',
        bg: 'white',
        border: '1px solid #0BD6A7',
        '&:hover, &:focus': {
          bg: 'rgb(11 214 167 / 10%);',
        },
      },
      secondary: {
        color: 'NightBlue',
        bg: 'greys.6',
        '&:hover, &:focus': {
          bg: 'LightGrey',
        },
      },
      destructive: {
        color: 'white',
        bg: 'NegativeChange',
        '&:hover, &:focus': {
          filter: 'brightness(95%)',
        },
      },
      disabled: {
        color: 'NightBlue',
        opacity: '50%',
        bg: 'greys.6',
        cursor: 'not-allowed',
        pointerEvents: 'none',
      },
      disablednotification: {
        color: 'NightBlue',
        bg: 'LightGrey',
        pointerEvents: 'none',
      },
    },
  })}
  ${compose(space, typography, color, border, flexbox, position, layout)}
`;

Button.defaultProps = {
  py: 2,
  px: 3,
  fontFamily: 'body',
  fontSize: 1,
  width: 'auto',
};

export default Button;
